import React from 'react';
import { formatTransactionHistoryTableCurrency } from '@/utils/currency-utils';
import { BffGamesTransactionsResponse } from '@lucky7ventures/bff-types';

export const mapGameTransactionHistoryItems = (
  locale: string,
  items: BffGamesTransactionsResponse | null,
) =>
  items?.map(item => {
    const currency = item.currency;
    const transactionDate = item.date;

    const bet = formatTransactionHistoryTableCurrency(item.bet, currency, locale);
    const win = formatTransactionHistoryTableCurrency(item.win, currency, locale);
    const dateMaintext = new Date(transactionDate).toLocaleDateString(locale, { timeZone: 'UTC' });
    const dateSubtext = `${new Date(transactionDate).toLocaleTimeString(locale, {
      timeZone: 'UTC',
    })} UTC`;
    const date = (
      <div>
        <p className="m-0">{dateMaintext}</p>
        <p className="m-0 text-[10px] md:text-[14px] text-gray-500">{dateSubtext}</p>
      </div>
    );
    return { game: item.game, bet, win, date };
  });
